type SalesPeopleOwner = { salesPeople?: { emailAddress: { value: string } }[] | null };

const salesPeopleEmailsOf = (owner: SalesPeopleOwner | undefined): string[] =>
	(owner?.salesPeople ?? []).map((salesPerson) => salesPerson.emailAddress.value);

export default salesPeopleEmailsOf;
